// src/components/Review/PovReviewPlayer.js
import React, { useEffect, useRef, useState } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import {readReviewTarget} from '../overview/reviewTaskTarget';
import VideoPlayerWithNotes from "./VideoPlayerWithNotes";

export default function PovReviewPlayer({
  mapId,
  mapName,
  initialVideoId,
  onBackToMaps,
  onBackToVideos,
}) {
  const navigate = useNavigate();
  const location=useLocation();
  const reviewTarget=readReviewTarget(new URLSearchParams(location.search));

  const [activeVideoId, setActiveVideoId] = useState(initialVideoId);
  const [deferUrlVideoId, setDeferUrlVideoId] = useState(null);

  // Keep it in sync if user lands directly on /review/:mapId/:videoId
  useEffect(() => {
    setActiveVideoId(initialVideoId);
  }, [initialVideoId]);

  useEffect(() => {
    if (!deferUrlVideoId) return;

    const syncUrlWhenSafe = () => {
      if (!document.fullscreenElement) {
        navigate(`/review/${mapId}/${deferUrlVideoId}`, { replace: true });
        setDeferUrlVideoId(null);
      }
    };

    document.addEventListener('fullscreenchange', syncUrlWhenSafe);
    syncUrlWhenSafe();

    return () => {
      document.removeEventListener('fullscreenchange', syncUrlWhenSafe);
    };
  }, [deferUrlVideoId, mapId, navigate]);

  // This object tells the player: "after you load the new POV, seek here"
  const [povSwitchRequest, setPovSwitchRequest] = useState(null);
  const reqCounterRef = useRef(0);

  const handleSwitchPov = ({
    nextVideoId,
    matchTimeSec,
    wasPlaying,
    wasFullscreen = false,
    wasSoftFullscreen = false,
    keepNotesOpen = false,
    keepNoteInputOpen = true,
  }) => {
    if (!nextVideoId || nextVideoId === activeVideoId) return;

    reqCounterRef.current += 1;

    setPovSwitchRequest({
      token: reqCounterRef.current,
      nextVideoId,
      matchTimeSec,
      wasPlaying,
      wasFullscreen,
      wasSoftFullscreen,
      keepNotesOpen,
      keepNoteInputOpen,
    });

    // Switch POV locally inside the same mounted player instance.
    // Do NOT navigate here, because route changes can break native fullscreen.
    setActiveVideoId(nextVideoId);
    setDeferUrlVideoId(nextVideoId);
  };

  return (
    <VideoPlayerWithNotes
      mapId={mapId}
      mapName={mapName}
      videoId={activeVideoId}
      initialReviewTarget={reviewTarget}
      onBackToMaps={onBackToMaps}
      onBackToVideos={onBackToVideos}
      onSwitchPov={handleSwitchPov}
      povSwitchRequest={povSwitchRequest}
    />
  );
}
